module.exports = __webpack_public_path__ + "static/media/banner-default.0f15790d.svg";